<template>
  <div class="rich-text">
    <div class="rich-text__content" v-html="renderedHtml"></div>
  </div>
</template>

<script>
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { INLINES, BLOCKS } from "@contentful/rich-text-types";

const options = {
  renderNode: {
    [INLINES.HYPERLINK]: (node) => {
      const url = node.data.uri;
      const text = node.content.map((child) => child.value).join("");
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="rich-text__link">${text}</a>`;
    },
    [BLOCKS.PARAGRAPH]: (node, next) => {
      const renderedChildren = next(node.content);

      // Check if paragraph is truly empty (or just whitespace)
      const isEmpty =
        !node.content ||
        node.content.length === 0 ||
        node.content.every(
          (n) => n.nodeType === "text" && n.value.trim() === ""
        );

      if (isEmpty) {
        // Render a single <br> to visually separate
        return "<br />";
      }

      return `<p>${renderedChildren}</p>`;
    },
  },
  renderText: (text) => {
    return text.replace(/\n/g, "<br />");
  },
};

export default {
  name: "ContentfulRichText",
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const renderedHtml = documentToHtmlString(props.content.json, options);
    return {
      renderedHtml,
    };
  },
};
</script>

<style lang="scss">
.rich-text {
  width: 100%;
  display: flex;
  text-align: left;

  &__content {
    ul,
    ol {
      margin-left: 1rem;
      padding-left: 1rem;
      list-style-position: outside;
    }
  }

  &__link {
    color: theme-color(pure-black);
  }
}
</style>
